import { ProjektRettighed, PublicProjektSag } from 'src/app/api/models';

export class InitiativPligtHelper {
  static GetInitiativPligtText(
    sag: PublicProjektSag,
    projektRettighed: ProjektRettighed | null
  ): string {
    switch (sag.initiativPligt) {
      case 'Ansoeger':
        return projektRettighed?.rettighed === 'ProjektEjer' ? 'Dig' : 'Ansøger';
      case 'Myndighed':
        return sag.ansvarligMyndighedNavn;
      default:
        return sag.initiativPligt;
    }
  }
}
